<template>
  <div @click="goToLink()" class="home-page-link-module">
    <div class="link-module-icon-div">
      <img :src="icon" alt="">
    </div>
    <div class="link-module-content">
      <div class="link-module-title">{{title}}</div>
      <div class="link-module-desc">{{desc}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "",
      required: true
    },
    desc: {
      type: String,
      default: "",
      required: true
    }
  },
  methods: {
    goToLink() {
      this.$emit("link");
    }
  }
};
</script>

<style  lang="scss" scoped>
.home-page-link-module {
  margin-left: 36px;
  margin-bottom: 36px;
  cursor: pointer;
}
.home-page-link-module:hover {
  background: #608ae8;
  color: #fff;
  .link-module-title,
  .link-module-desc {
    color: #fff !important;
  }
}
.home-page-link-module:nth-child(4n + 1) {
  margin-left: 0;
}
.home-page-link-module {
  display: inline-block;
  background: rgba(255, 255, 255, 1);
  height: 240px;
  width: 273px;
  box-shadow: 0px 3px 9px 4px rgba(143, 143, 143, 0.09);
  .link-module-icon-div {
    width: 110px;
    height: 110px;
    margin: 36px auto 22px;
    border-radius: 110px;
    background: #e5ecfd;
    text-align: center;
    line-height: 110px;
    overflow: hidden;
    img{
      max-width: 100%;
      max-height: 100%;
    }
  }
  .link-module-content {
    text-align: center;
    .link-module-title {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(22, 34, 50, 1);
    }
    .link-module-desc {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(164, 164, 164, 1);
      line-height: 36px;
    }
  }
}
</style>